/** 
 *   后台管理 api
 */

 import { get, post, put, del } from '@/untils/axios.js'



 /*************************** 财务管理 ***************************/
 // 交易查询
 export const search    = params => get('/finance/transaction-list', params)
 // 物流结算
 export const logistics = params => get('/finance/logistics', params)
 // 退款列表
 export const refund    = params => get('/finance/refundlist', params)
 // 提交退款
 export const refund_submit = params => post('/finance/refundhandle', params)
 // 提现列表
 export const withdrawal    = params => get('/finance/user-withdrawal-list', params)
 // 财务报表
 export const report    = params => get('/finance/transaction-report', params)
 // 销售报表
 export const refund_report = params => get('/finance/sales-report', params)
 // 退款报表
 export const reimburse = params => get('/finance/refund-report', params)
 // Monthly Bookkeeping
 export const monthly_bookkeeping = params => get('/finance/monthly-bookkeeping', params)
 
 /*************************** 栏目 ***************************/
 
 // 栏目 列表
 export const columns = params => get('columns', params)
 // 栏目 添加
 export const columns_add = params => post('columns', params)
 // 栏目 更新
 export const columns_put = (id,params) => put(`columns/${id}`, params)
 // 栏目 删除
 export const columns_del = id => del(`columns/${id}`)
 
 
 /*************************** 权限 ***************************/
 
 // 权限 列表
 export const permission = params => get('permission', params)
 // 权限 添加
 export const permission_add = params => post('permission', params)
 // 权限 更新
 export const permission_put = (id,params) => put(`permission/${id}`, params)
 // 权限 删除
 export const permission_del = id => del(`permission/${id}`)
 
 
 /*************************** 角色 ***************************/
 
 // 角色 列表
 export const roles = params => get('roles', params)
 // 角色 添加
 export const roles_add = params => post('roles', params)
 // 角色 更新
 export const roles_put = (id,params) => put(`roles/${id}`, params)
 // 角色 删除
 export const roles_del = id => del(`roles/${id}`)
 
 
 /*************************** 管理员 ***************************/
 
 // 管理员 列表
 export const manager = params => get('manager', params)
 // 管理员 添加
 export const manager_add = params => post('manager', params)
 // 管理员 更新
 export const manager_put = (id,params) => put(`manager/${id}`, params)
 // 管理员 删除
 export const manager_del = id => del(`manager/${id}`)
 // 查询角色  不分页
 export const get_roles = params => get('roles/getroles', params)
 
 
 
 /*************************** 客服 ***************************/
 
 // 客服 列表
 export const cusmoter = params => get('commentkf', params)
 // 客服 添加
 export const cusmoter_add = params => post('commentkf', params)
 // 客服 更新
 export const cusmoter_put = (id,params) => put(`commentkf/${id}`, params)
 // 客服 删除
 export const cusmoter_del = id => del(`commentkf/${id}`)
 
 
 
 
 /*************************** 用户 ***************************/
 
 // 会员 列表
 export const member = params => get('member/list', params)
 // 管理员 更新
 export const member_put = (id,params) => put(`member/update/${id}`, params)
 // 平台/夜市/其他用户列表
 export const member_activity_list = (type,params)=> get(`member/sms-users-list/${type}`,params)
 // 平台管理群发信息
 export const member_send_activity_msg = (type,params) => post(`member/send-users-msg/${type}`,params) 
 
//  黑名单 列表
export const blacklist = params => get('/order/blacklist', params)
// 黑名单 添加
export const blacklist_add = params => post('/order/blacklist', params)
// 黑名单 删除
export const blacklist_del = id => del(`/order/blacklist/${id}`)


 /*************************** 平台反馈 ***************************/
 
 // 反馈 列表
 export const feedback = params => get('feedback/list', params)
 
 /*************************** 省份税率 ***************************/
 
 // 省份税率 列表
 export const tax_list = params => get('tax/setting', params)
 
 // 省份税率 修改
 export const tax_edit = (id,params) => put(`tax/setting/${id}`, params)

// 消息通知
 export const after_sale = params => get(`aftersale/number`, params)


 
// 消息通知
export const user_retain = params => get(`night/market/activity/user/retain`, params)


// 消息通知
export const user = params => get(`night/market/user`, params)